import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, computed, PropType } from 'vue'
import { useFilterStore } from '@/stores/HomeFilterStore'
import Points from './Points.vue'
import { MapCableDataPoint, CableVessel } from '@/server/MakeSenseApp-backend'
import Cable from './Cable.vue'
import CableDepthofBurial from './CableDepthofBurial.vue'
import CableTemperature from './CableTemperature.vue'
import CableAcoustics from './CableAcoustics.vue'
import Vessels from './Vessels.vue'
import InteractionSelect from './InteractionSelect.vue'
import PopupMap from './PopupMap.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'MainMap',
  props: {
  sensorReadings: {
    type: Array as PropType<MapCableDataPoint[]>,
    required: true
  },
  vessels: {
    type: Array as PropType<CableVessel[]>,
    required: true
  },
  center: Array<Number>,
  cableLength: Number
},
  setup(__props) {

const projection = ref('EPSG:3857')
const zoom = ref(9)
const isLoading = ref(true)

var props = __props

const filterStore = useFilterStore()

const isDTSActive = computed(() => filterStore.isDTSActive)
const isDoBActive = computed(() => filterStore.isDoBActive)
const isDASActive = computed(() => filterStore.isDASActive)
const isVesselActive = computed(() => filterStore.isVesselActive)

const isFishingActive = computed(() => filterStore.isFishingActive)
const isCargoActive = computed(() => filterStore.isCargoActive)
const isTankerActive = computed(() => filterStore.isTankerActive)
const isUnderwaterActive = computed(() => filterStore.isUnderwaterActive)
const isDivingActive = computed(() => filterStore.isDivingActive)
const isPassengerActive = computed(() => filterStore.isPassengerActive)
const isOtherActive = computed(() => filterStore.isOtherActive)
const isUnknownActive = computed(() => filterStore.isUnknownActive)

const filteredVessels = computed(() => {
  return props.vessels.filter((vessel) => {
    if (isFishingActive.value && vessel.vesselType === 0) {
      return true
    }

    if (isCargoActive.value && vessel.vesselType === 1) {
      return true
    }

    if (isTankerActive.value && vessel.vesselType === 2) {
      return true
    }

    if (isUnderwaterActive.value && vessel.vesselType === 3) {
      return true
    }

    if (isDivingActive.value && vessel.vesselType === 4) {
      return true
    }

    if (isPassengerActive.value && vessel.vesselType === 5) {
      return true
    }

    if (isUnknownActive.value && vessel.vesselType === 6) {
      return true
    }

    if (isOtherActive.value && vessel.vesselType === 7) {
      return true
    }

    return false
  })
})

return (_ctx: any,_cache: any) => {
  const _component_ol_view = _resolveComponent("ol-view")!
  const _component_ol_source_osm = _resolveComponent("ol-source-osm")!
  const _component_ol_tile_layer = _resolveComponent("ol-tile-layer")!
  const _component_ol_zoom_control = _resolveComponent("ol-zoom-control")!
  const _component_ol_map = _resolveComponent("ol-map")!

  return (isLoading.value)
    ? (_openBlock(), _createBlock(_component_ol_map, {
        key: 0,
        controls: [],
        style: {"height":"100%"},
        projection: projection.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ol_view, {
            center: __props.center,
            zoom: zoom.value,
            projection: projection.value
          }, null, 8, ["center", "zoom", "projection"]),
          _createVNode(_component_ol_tile_layer, { className: "dts-background-map" }, {
            default: _withCtx(() => [
              _createVNode(_component_ol_source_osm)
            ]),
            _: 1
          }),
          _createVNode(_component_ol_zoom_control, {
            className: "ol-zoom",
            zoomInLabel: "+",
            zoomOutLabel: "-"
          }),
          _createVNode(InteractionSelect, {
            sensorReadings: __props.sensorReadings,
            vessels: filteredVessels.value
          }, null, 8, ["sensorReadings", "vessels"]),
          _createVNode(Vessels, {
            "is-visible": isVesselActive.value,
            "vessel-data": filteredVessels.value
          }, null, 8, ["is-visible", "vessel-data"]),
          _createVNode(CableAcoustics, {
            sensorReadings: __props.sensorReadings.filter((x) => x.das !== null),
            isVisible: isDASActive.value
          }, null, 8, ["sensorReadings", "isVisible"]),
          _createVNode(CableTemperature, {
            sensorReadings: __props.sensorReadings,
            isVisible: isDTSActive.value
          }, null, 8, ["sensorReadings", "isVisible"]),
          _createVNode(CableDepthofBurial, {
            sensorReadings: __props.sensorReadings,
            isVisible: isDoBActive.value
          }, null, 8, ["sensorReadings", "isVisible"]),
          _createVNode(Cable, {
            sensorReadings: __props.sensorReadings,
            isVisible: true
          }, null, 8, ["sensorReadings"]),
          _createVNode(Points, {
            sensorReadings: __props.sensorReadings,
            isVisible: false
          }, null, 8, ["sensorReadings"]),
          _createVNode(PopupMap, {
            isVisible: true,
            cableLength: __props.cableLength
          }, null, 8, ["cableLength"])
        ]),
        _: 1
      }, 8, ["projection"]))
    : _createCommentVNode("", true)
}
}

})